import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import { get_documents } from '../store/actions/documentActions';
import Header from '../containers/header';
import Table from '../components/table';
import Footer from '../containers/footer';
import Sidebar from '../components/Sidebar';
import ListCard from '../components/List-Card';
import TableCard from '../components/table-card';
import DetailCard from '../components/DetailCard';
import ButtonList from '../containers/buttonList';
import  CeleryProgressBar from '../Celery/celery_progress';
import  ResultCeleryProgressBar from '../Celery/result_celery_progress';
const path = require('path'); 

class WorkArea extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            document : {},
            card : {content: 'tweet'},
            position : '',

        };
        this.handleClick = this.handleClick.bind(this)
        this.handleDelete = this.handleDelete.bind(this);; 
    }
    componentDidMount() {
      if (this.props.token) {
        
      const documentID = this.props.match.params.documentID;
      axios.defaults.headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${this.props.token}`
      };
      axios.get(`https://apa-reference-finder-backend-3.herokuapp.com/api/${documentID}`).then(res => {
         this.setState({
           document: res.data,
           position: 'incorrect'
         });
       
       }); 
      }
        
 }

 componentDidUpdate(prevProps){
      
  if (prevProps.token !== this.props.token) {
    
  const documentID = this.props.match.params.documentID;  
  axios.defaults.headers = {
    "Content-Type": "application/json",
    Authorization: `Token ${this.props.token}`
  };
  axios.get(`https://apa-reference-finder-backend-3.herokuapp.com/api/${documentID}`).then(res => {
         this.setState({
           document: res.data,
           position: 'authors'
         });
       
       }); 
    }
}
    handleClick = (event) => {
        const linkclick = document.querySelectorAll('.click');
        for (let item of Array.from(linkclick)) {
        
        if ( event.target.getAttribute('data-position') !== null){
        this.setState({
          position: String(event.target.getAttribute('data-position'))
         });}
         if (item  === event.target) {
          item.parentElement.style.background = '#1b9bff';
          }
          else{
            item.parentElement.style.background = 'white';
          }
      }
      }; 
      handleDelete = event => {
        event.preventDefault();
        if (window.confirm('Click OK to confirm delete')) {
          const documentID = this.props.match.params.documentID;
        axios.defaults.headers = {
          "Content-Type": "application/json",
          Authorization: `Token ${this.props.token}`
        };
        axios.delete(`https://apa-reference-finder-backend-3.herokuapp.com/api/${documentID}/`)
        .then(res => {
         
          if (res.status === 204) {
            this.props.history.push(`/HistoryList/`);
            this.props.get_documents(this.props.token)
          }
        })
        }
        
      };
      
    render() {
      
      var validate = this.state.document.validate
      var htmlContent = this.state.document.htmlContent
      var result_task_id = this.state.document.result_task_id
      var html_task_id = this.state.document.html_task_id
      var waiting = <p>'Waiting for reference comparison process to start...'</p>
      var htmlwaiting = <p>'Waiting for document view process to start...'</p>
      
      if (html_task_id !== undefined && html_task_id !== null && (htmlContent === undefined || htmlContent === null))
      {
        var actual_html_task_id = html_task_id.task_id
        var htmlprogressUrl = `https://apa-reference-finder-backend-3.herokuapp.com/celery-progress/${actual_html_task_id}`
        CeleryProgressBar.initProgressBar(htmlprogressUrl);
      }
      else {
        htmlwaiting = null
      }
      if (result_task_id !== undefined && result_task_id !== null && (validate === undefined || validate === null))
      {
        
        var actual_result_task_id = result_task_id.task_id
        var resultprogressUrl = `https://apa-reference-finder-backend-3.herokuapp.com/celery-progress/${actual_result_task_id}`
        ResultCeleryProgressBar.initProgressBar(resultprogressUrl);
      }
      else {
        waiting = null
      }

      var listItems = null

      if (validate !== undefined && validate !== null && this.state.position === 'textReferences') {
        const list = JSON.parse(validate.references_list)
        listItems = list.map((reference, index)  => <ListCard key = {index} content = {<p>{reference}</p>} /> ); 
      }
      else if (validate !== undefined && validate !== null && this.state.position === 'authors') {
        const list = JSON.parse(validate.one_author_list)
        const et_al = JSON.parse(validate.et_al_list)
        let single_author_list = list.filter(dict => dict.second_author == null ).map((dict, index)  => <ListCard key = {index} content = {<p>{dict.Author_name}, {dict.year}</p>} /> ); 
        let two_authors_list = list.filter(dict => dict.second_author).map((dict, index)  => <ListCard key = {single_author_list.length + index} content = {<p>{dict.Author_name} and {dict.second_author}, {dict.year}</p>} /> ); 
        let single_and_two = [...single_author_list, ...two_authors_list]
        let et_al_list = et_al.map((dict, index)  => <ListCard key = {single_and_two.length + index} content = {<p>{dict.Author_name} et al, {dict.year}</p>} /> ); 
        listItems = (et_al_list.concat(single_and_two))
      }
      else if (validate !== undefined && validate !== null && this.state.position === 'incorrect') { 
        const list = JSON.parse(validate.incorrect)
        const bib_list = JSON.parse(validate.incorrectBib)
        let single_author_list = list.filter(dict => dict.second_author == null ).map((dict, index)  => <TableCard key = {index} content = {<p>{dict.Author_name}, {dict.year}</p>} /> ); 
        let two_authors_list = list.filter(dict => dict.second_author).map((dict, index)  => <TableCard key = {single_author_list.length + index} content = {<p>{dict.Author_name} and {dict.second_author}, {dict.year}</p>} /> ); 
        let single_author_bib_list = bib_list.filter(dict => dict.second_author == null ).map((dict, index)  => <TableCard key = {index} content = {<p>{dict.Author_name}, {dict.year}</p>} /> ); 
        let two_authors_bib_list = bib_list.filter(dict => dict.second_author).map((dict, index)  => <TableCard key = {single_author_bib_list.length + index} content = {<p>{dict.Author_name} and {dict.second_author}, {dict.year}</p>} /> ); 
        let single_and_two = [...single_author_list, ...two_authors_list]
        let single_and_twoBib = [...single_author_bib_list, ...two_authors_bib_list]
        listItems = <Table incorrect ={single_and_two} incorrectBib ={single_and_twoBib} />
        
      }
      else if (htmlContent !== undefined && htmlContent !== null && this.state.position === 'html') { 
         const content = htmlContent.content
         listItems =  <DetailCard content={content}/> 
      }
      var content =  <div>
                    <div className='progress-wrapper'>
              <div id='result-progress-bar' className='progress-bar' >&nbsp;</div>
              </div>
              <div id="result-progress-bar-message">{waiting}</div>
              </div>
      var htmlcontent = <div>
                        <div className='progress-wrapper'>
                  <div id='progress-bar' className='progress-bar' >&nbsp;</div>
                  </div>
                        <div id="progress-bar-message">{htmlwaiting}</div>
                  </div>
        return (
            <div className='body'>
         <Header change={this.handleClick}>
         <ul className='navigation' >
              <li><Link to='/' className='click' >Home</Link></li>
              
              <li><Link to='/HistoryList/' className='click' >View History</Link></li>
            </ul>
             </Header>
         
         <Sidebar height={"100vh"} width ={300}>
         <ul className='not-navigation'>
              <li><Link to='/' className='click' >Home</Link></li>
              <li><Link to='/HistoryList/' className='click' >View History</Link></li>
            </ul>
            <ButtonList Click={this.handleClick}/>
          </Sidebar>
         <div className='page-content'>
         <div className='input-area' id='home'>
            <form onSubmit={this.handleDelete}>
              <button id="delete" type="submit" >
                Delete
              </button>
            </form>
                {content}
                {htmlcontent}
  
         </div>

         <div className='how-it-works-area' id='get-started-area'> <ListCard content={<h1><a className='headerLink' href='#list-area'>{path.basename(this.state.document.document, '.docx')}</a></h1>}/> </div>
         
        <div className='list-area' id='list-area'>{listItems}</div>
        
         </div>
       <Footer/>
        </div>
 
)
    };    
}    
const mapStateToProps = state => {
  return {
    token: state.token 
  }
}
const mapDispatchToProps = dispatch => {
  return {
    get_documents: (token) => dispatch(get_documents(token))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WorkArea);
